import { render, staticRenderFns } from "./BlankInput.vue?vue&type=template&id=897e68e4&scoped=true&"
import script from "./BlankInput.vue?vue&type=script&lang=js&"
export * from "./BlankInput.vue?vue&type=script&lang=js&"
import style0 from "./BlankInput.vue?vue&type=style&index=0&id=897e68e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897e68e4",
  null
  
)

component.options.__file = "BlankInput.vue"
export default component.exports